import SettingsView from './views/SettingsView'

export default [
  {
    path: 'account/settings',
    name: 'account-settings',
    component: SettingsView
  }
]

